/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import DatePicker from '../../components/datePicker';
import { useParams } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { DataTableComp } from '../../components/dataTable';
import { getLocationDetails } from '../../redux/slices/location/locationDetails';
import {
  ANALYTICS_NAVBAR_ACTIONS,
  BEST_TIME_TO_POST_LABEL,
  configsMap,
  GROWTH_LABEL,
  newConfigsMap,
  configmapForLinkedinPersonalOnly,
  OVERVIEW_LABEL,
  DEMOGRAPHICS_LABEL,
  POST_PERFORMANCE_LABEL,
  CAMPAIGN_ANALYTICS_LABEL
} from '../dashboard/config';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { DEFAULT_RANGE } from '../../components/datePicker/utils';
import {
  getAnalyticsForLocation,
  transferData
} from '../../redux/slices/analytics/plotsData';
import { formatDate, getAllDates } from '../../utils/dateUtils';
import { data } from '../dashboard/demoDataDocument';
import { getUserDetails } from '../../redux/slices/user/userDetails';
import { useTranslate } from '@tolgee/react';
import {
  allPlatformsGrowthConfig,
  contentGrowthConfig,
  dailyGrowthConfig,
  followersGrowthConfig
} from './growthConfig';
import { distrubutedGrowthConfig } from './distrubutedGrowthConfig';
import PlatformHeatmapList from '@/components/analytics/heatmapList';
import AnalyticsPagesLayout from '@/components/analyticsPagesLayout';
import { fetchDemographics } from '@/redux/slices/analytics/demographics';
import DemographicsTab from './DemographicsTab';
import BestTimeToPostTab from './BestTimeToPostTab';
import GrowthTab from './GrowthTab';
import DemographicsMap from '@/components/analytics/demographicsMap';
import { getCurrentLocationUUID } from '../../utils/communicationUtils';
import AllAnalyticsOverviewTab from './AllAnalyticsOverviewTab';

import { ThunkDispatch } from '@reduxjs/toolkit';
import { lomavisShowToastr } from '@/utils/ui/toastr';
import PostPerformance from './sections/postPerformance';
import CampaignAnalysis from './sections/campaignAnalytics';

const AllAnalytics: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>();
  // cut config based on platforms
  const { isLoading, uuid, demo, show_data_import_info, platforms } =
    useSelector((state: any) => state.locationDetails);

  const { locationslug } = useParams();

  useEffect(() => {
    dispatch(getUserDetails() as unknown as AnyAction);
  }, [dispatch]);

  useEffect(() => {
    if (locationslug ?? '')
      dispatch(getLocationDetails(locationslug) as unknown as AnyAction);
  }, [dispatch, locationslug]);

  // Fetch demographics data when uuid is available
  useEffect(() => {
    if (uuid && !demo) {
      dispatch(fetchDemographics(uuid) as any);
    }
  }, [dispatch, uuid, demo]);

  const [dates, setDates] = useState({
    ...DEFAULT_RANGE
  });
  const type = 'dashboard_data_for_location';
  const [plotsData, setPlotsData] = useState({} as any);
  const [oldPlotsData, setOldPlotsData] = useState({} as any);
  const [loading, setLoading] = useState(true);
  const [loadingOld, setLoadingOld] = useState(true);
  const [error, setError] = useState(false);
  const { t } = useTranslate();
  const locationUuid = getCurrentLocationUUID();

  // Determine which config to use based on connected platforms
  const activeConfigMap = useMemo(() => {
    if (!platforms) return newConfigsMap;

    const connectedPlatforms = Object.entries(platforms).filter(
      ([_, isConnected]) => isConnected
    );
    const isOnlyLinkedinPersonal =
      connectedPlatforms.length === 1 && platforms.linkedin_personal_account;

    console.log('Is LinkedIn Personal Only:', isOnlyLinkedinPersonal);
    console.log(
      'Connected Platforms:',
      connectedPlatforms.map(([name]) => name)
    );
    console.log(
      'Using Config:',
      isOnlyLinkedinPersonal
        ? 'configmapForLinkedinPersonalOnly'
        : 'newConfigsMap'
    );

    return isOnlyLinkedinPersonal
      ? configmapForLinkedinPersonalOnly
      : newConfigsMap;
  }, [platforms]);

  useEffect(() => {
    if (!uuid || !dates || isLoading) return;

    setLoading(true);
    setLoadingOld(true);

    // Handle demo mode
    if (demo) {
      setPlotsData(data);
      setLoading(false);
      return;
    }

    // Fetch current plots
    getAnalyticsForLocation('analytics_for_location', type, uuid, dates)
      .then((res) => {
        setError(false);
        console.log(res, 'result from fb');
        const newData = transferData(res, activeConfigMap);
        console.log(newData, 'newPlotsData');
        setPlotsData(newData);
        setLoading(false);

        // Calculate old date range (only after current fetch)
        const dateRange = getAllDates(dates.startDate, dates.endDate).length;
        const oldStartDate = new Date(dates.startDate);
        oldStartDate.setDate(oldStartDate.getDate() - dateRange);

        const oldEndDate = new Date(dates.startDate);
        oldEndDate.setDate(oldEndDate.getDate() - 1);

        const oldDates = {
          startDate: oldStartDate,
          endDate: oldEndDate
        };

        // Fetch old plots
        return getAnalyticsForLocation(
          'analytics_for_location',
          type,
          uuid,
          oldDates
        );
      })
      .then((oldRes) => {
        if (oldRes) {
          const oldData = transferData(oldRes, activeConfigMap);
          setOldPlotsData(oldData);
          console.log(oldData, 'oldPlotsData');
          setLoadingOld(false);
        }
      })
      .catch((err) => {
        console.log(err, 'fetch error');
        setError(true);
        setLoading(false);
        setLoadingOld(false);
      });
  }, [uuid, dates, isLoading, activeConfigMap]);

  console.log(error, 'error');
  console.log(plotsData, 'plotsData');
  console.log(oldPlotsData, 'oldPlotsData');
  // ---
  // Define available platforms for demographics

  return (
    <Container>
      <div className="m-2" />

      <AnalyticsPagesLayout
        actions={ANALYTICS_NAVBAR_ACTIONS}
        tabs={{
          [OVERVIEW_LABEL]: (
            <AllAnalyticsOverviewTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              oldPlotsData={oldPlotsData}
              loading={loading}
              error={error}
              followersGrowthConfig={followersGrowthConfig}
              allPlatformsGrowthConfig={allPlatformsGrowthConfig}
              dailyGrowthConfig={dailyGrowthConfig}
              contentGrowthConfig={contentGrowthConfig}
              distrubutedGrowthConfig={distrubutedGrowthConfig}
            />
          ),
          [BEST_TIME_TO_POST_LABEL]: <BestTimeToPostTab />,
          [GROWTH_LABEL]: (
            <GrowthTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              loading={loading}
              error={error}
              show_data_import_info={show_data_import_info}
              locationslug={locationslug}
              activeConfigMap={activeConfigMap}
            />
          ),
          [POST_PERFORMANCE_LABEL]: <PostPerformance />,
          [DEMOGRAPHICS_LABEL]: <DemographicsTab />,
          [CAMPAIGN_ANALYTICS_LABEL]: <CampaignAnalysis />
        }}
      />
    </Container>
  );
};

export default AllAnalytics;
